/*
 * @Description: 对象工具类
 * @Author: LiuYongChun
 * @Date: 2020-12-07 13:15:32
 * @LastEditors: LiuYongChun
 * @LastEditTime: 2020-12-07 13:48:31
 */


 class ObjectUtil {
   /**
    * @author: LiuYongChun
    * @description: 清空目前对象值
    * @param {any} obj
    * @return {*}
    */
   static clearValue(obj: object) {
     if (!obj) {
       return;
     }
     Object.keys(obj).forEach((key) => {
       if (typeof obj[key] === 'string') {
         obj[key] = '';
       }
       if (typeof obj[key] === 'number') {
        obj[key] = 0;
      }
      if (typeof obj[key] === 'boolean') {
        obj[key] = false;
      }
      if (Array.isArray(obj[key])) {
        obj[key] = Array.of();
      }
      if (typeof obj[key] === 'object') {
        this.clearValue(obj[key]);
      }
     })
   }
 }

 export default ObjectUtil;